/* PELYKO — accueil orienté.
   1) Page d'accueil : ouvre le choix d'animal une seule fois par visiteur,
      juste après l'ouverture de marque, et le retient.
   2) Page sélecteur : si l'URL porte ?animal=..., saute directement à l'étape
      correspondante au lieu de redemander. */
(function () {
  var KEY = 'pelyko-bienvenue';
  var PAGE = '/pages/quel-produit-choisir';

  function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return true; } }
  function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

  /* ---------- 1. La fenêtre d'accueil ---------- */
  var box = document.getElementById('pk-welcome');
  if (box && !seen()) {
    var opener = null, lastFocus = null;

    var close = function () {
      remember();
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () { box.hidden = true; }, 300);
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    var onKey = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = box.querySelectorAll('button');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    var open = function () {
      if (seen()) return;
      lastFocus = document.activeElement;
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () {
        box.classList.add('is-open');
        var first = box.querySelector('[data-pkw-go]');
        if (first) first.focus({ preventScroll: true });
      });
      document.addEventListener('keydown', onKey);
    };

    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    box.querySelectorAll('[data-pkw-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    box.querySelectorAll('[data-pkw-go]').forEach(function (b) {
      b.addEventListener('click', function () {
        remember();
        window.location.href = PAGE + '?animal=' + encodeURIComponent(b.dataset.pkwGo);
      });
    });

    /* L'ouverture de marque annonce son départ ; sinon on ouvre peu après le chargement. */
    var fired = false;
    var go = function () { if (fired) return; fired = true; window.setTimeout(open, 260); };
    document.addEventListener('pk-intro-leaving', go, { once: true });
    if (!document.getElementById('pk-entry')) {
      window.setTimeout(go, 900);
    } else {
      opener = window.setTimeout(go, 7000); /* filet de sécurité si l'intro ne finit pas */
    }
  }

  /* ---------- 2. Arrivée sur le sélecteur avec une réponse déjà donnée ---------- */
  if (location.pathname.indexOf(PAGE) === 0) {
    var animal = null;
    try { animal = new URLSearchParams(location.search).get('animal'); } catch (e) {}
    if (animal) {
      var jump = function () {
        var btn = document.querySelector('[data-animal="' + animal.replace(/[^a-z]/g, '') + '"]');
        if (btn) btn.click();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jump, { once: true });
      else jump();
    }
  }
})();